import React from "react";
import { components } from "react-select";
import { ControlLabel } from "react-bootstrap";
import ChrSelect from "../../../generic/Form/Basic/ChrSelect";
import ChrTooltip from "../../../generic/Form/Basic/ChrTooltip";
import i18n from "../../../../utils/ChrI18n";

// Custom Option Component with star icon (for Connection View)
const ConnectionViewOption = (props) => {
  const { data } = props;
  const starClass = data.favorite ? "fa-solid fa-star" : "fa-regular fa-star";
  return (
    <components.Option {...props}>
      <div className="d-flex align-items-start flex-gap-8">
        <div><i className={`fa-fw ${starClass} text-muted`}></i></div>
        <div className="flex-grow-1">
          <div>{data.label}</div>
          {data.description && (
            <div className="text-muted font-12">{data.description}</div>
          )}
        </div>
      </div>
    </components.Option>
  );
};

// Custom Menu Component with "Create new view" link
const ConnectionViewMenu = (props) => {
  const { groupsPath, canManageGroupViews } = props.selectProps;

  const handleCreateViewTouchEnd = (event) => {
    window.open(groupsPath, '_blank');
  };

  return (
    <components.Menu {...props}>
      {props.children}
      {canManageGroupViews && (
        <a href={groupsPath} onTouchEnd={handleCreateViewTouchEnd} target="_blank" rel="noopener noreferrer" className="d-flex flex-gap-8 p-x-12 p-y-6-important cjs_create_connection_view_link">
          <div><i className="fa-regular fa-plus fa-fw"></i></div>
          {i18n.t("feature.admin_view.header.create_new_view")}
        </a>
      )}
    </components.Menu>
  );
};

const SiloBustingFilterPane = (props) => {
  const {
    selectedConnectionView,
    onConnectionViewChange,
    selectedProfileQuestion,
    onProfileQuestionChange,
    connectionViewOptions,
    profileQuestionOptions,
    groupsPath,
    canManageGroupViews = false,
    isChartDataLoading = false
  } = props;

  const handleConnectionViewChange = (event, _childUId, childData) => {
    onConnectionViewChange(childData);
  };

  const handleProfileQuestionChange = (event, _childUId, childData) => {
    onProfileQuestionChange(childData);
  };

  return (
    <div className="cui_silo_busting_filter_pane">
      <div className="d-flex flex-row flex-md-column flex-gap-24">
        <div className="flex-grow-1 cui_silo_busting_dropdown_wrapper">
          <ControlLabel className="font-weight-600 m-b-xs d-flex align-items-center flex-gap-5">
            {i18n.t("widgets.silo_busting.connection_view", jsConstants.customTerms)}
            <ChrTooltip
              content={i18n.t("widgets.silo_busting.connection_view_tooltip", jsConstants.customTerms)}
              iconClass="fa-regular fa-info-circle text-muted"
              ariaLabel={ i18n.t("widgets.silo_busting.connection_view_tooltip", jsConstants.customTerms) }
            />
          </ControlLabel>
          <ChrSelect
            uId="silo_busting_connection_view_dropdown"
            formGroupClass="no-margins"
            reactSelectOptions={{
              options: connectionViewOptions,
              value: selectedConnectionView,
              closeMenuOnSelect: true,
              blurInputOnSelect: true,
              menuShouldScrollIntoView: true,
              components: {
                Option: ConnectionViewOption,
                Menu: ConnectionViewMenu,
                IndicatorSeparator: () => null
              },
              isSearchable: true,
              isDisabled: isChartDataLoading,
              className: "cui_silo_busting_connection_view_dropdown",
              groupsPath: groupsPath,
              canManageGroupViews: canManageGroupViews
            }}
            placeholder={i18n.t("widgets.silo_busting.connection_view", jsConstants.customTerms)}
            onChange={handleConnectionViewChange}
          />
        </div>

        <div className="flex-grow-1 cui_silo_busting_dropdown_wrapper">
          <ControlLabel className="font-weight-600 m-b-xs">
            {i18n.t("widgets.silo_busting.explore_by")}
          </ControlLabel>
          <ChrSelect
            uId="silo_busting_profile_questions_dropdown"
            formGroupClass="no-margins"
            reactSelectOptions={{
              options: profileQuestionOptions,
              value: selectedProfileQuestion,
              closeMenuOnSelect: true,
              blurInputOnSelect: true,
              menuShouldScrollIntoView: true,
              components: {
                IndicatorSeparator: () => null
              },
              isSearchable: true,
              isDisabled: isChartDataLoading,
              className: "cui_silo_busting_profile_questions_dropdown",
            }}
            placeholder={i18n.t("feature.reports.content.profile_question")}
            onChange={handleProfileQuestionChange}
          />
        </div>
      </div>
    </div>
  );
};

export default SiloBustingFilterPane;